/**
 * @file contract-review-labels.ts
 * @description 合約評審單枚舉值 → 中文標籤 / Tag 顏色的集中映射。
 *
 * 供 ContractReviewPanel（評審歷史列表）與 ContractReviewDrawer（抽屜標題）共用，
 * 避免在多處重複硬編碼英文枚舉或翻譯。
 */

import type { ContractReviewDTO } from '@/lib/api-client';

/** 評審單流轉狀態 → 中文標籤 + antd Tag preset 顏色 */
export const REVIEW_STATUS_META: Record<
  ContractReviewDTO['status'],
  { color: string; text: string }
> = {
  draft: { color: 'default', text: '草稿' },
  lead_submitted: { color: 'processing', text: '組長已提交' },
  manager_approved: { color: 'success', text: '總經理已通過' },
  rejected: { color: 'error', text: '已駁回' },
};

/**
 * 批示結論 → 中文標籤（序60.3：受理文案改為「受理，發 TAF 認證標誌證書」）。
 * reject_fixable / reject_terminal 皆屬「不受理」，保留可補正 / 結案的細分供歷史展示。
 */
export const CONCLUSION_LABEL: Record<NonNullable<ContractReviewDTO['conclusion']>, string> = {
  accept: '受理，發 TAF 認證標誌證書',
  reject_fixable: '不受理（可補正）',
  reject_terminal: '不受理（結案）',
};

/**
 * 驗證組長決議 → 中文標籤（序59.4）。
 * accept_taf：受理，發 TAF 認證標誌證書；reject：不受理（原因見驗證組長意見）。
 */
export const LEAD_DECISION_LABEL: Record<NonNullable<ContractReviewDTO['leadDecision']>, string> = {
  accept_taf: '受理，發 TAF 認證標誌證書',
  reject: '不受理',
};
